import React from 'react';
import { Grid } from '@material-ui/core';

const REFACTOR_DATE = '2025-08-19 14:10:00';

function Row({ children, justifyContentStart, marginTop = 0 }) {
  return(
    <Grid style={{ display: 'flex', flexDirection: 'row', justifyContent: justifyContentStart ? 'flex-start' : 'space-between', width: '100%', color: '#1e5168', marginTop }}>
      {children}
    </Grid>
  );
}

function Column({ children }) {
  return(
    <Grid style={{ display: 'flex', flexDirection: 'column', width: '100%', color: '#1e5168', padding: 8 }}>
      {children}
    </Grid>
  );
}

const getUserNameById = (userList, userId) => {
  const user = userList?.find(user => user.value == userId);
  return user?.label;
}

const getContractNameById = (contractNameList, contractId) => {
  const contract = contractNameList?.find(contract => contract.value == contractId);
  return contract?.label;
}

const getCategoryMethodNameById = (categories, categoryId) => {
  const category = categories?.find(category => +category.categoryId == +categoryId);
  return category?.categoryName || '--';
}

const getAccountNameById = (accounts, accountId) => {
  const account = accounts?.find(account => +account.value == +accountId);
  return account?.label || '--';
}

const getPaymentMethodNameById = (paymentMethods, paymentMethodId) => {
  const paymentMethod = paymentMethods?.find(paymentMethod => paymentMethod.value == paymentMethodId);
  return paymentMethod?.label || '--';
}

export {
  REFACTOR_DATE,
  Row,
  Column,
  getUserNameById,
  getContractNameById,
  getCategoryMethodNameById,
  getAccountNameById,
  getPaymentMethodNameById
}